// extracted by mini-css-extract-plugin
module.exports = {"video":"BodySubIntroduction_video_1IauW"};